module.exports = __webpack_public_path__ + "static/media/1001449.065e622c.png";